<script>
import _ from 'lodash';
import { VAutocomplete } from 'vuetify/lib';
import BReadOnlyTextField from '../BReadOnlyTextField';
import ValidationField from "@/components/base_components/ValidationField";

const currentSelectionText = props => {
  const itemValue = props.itemValue || 'value';
  const itemText = props.itemText || 'text';
  const currentSelection = props.items.find(
    i => _.get(i, itemValue) == props.value
  );
  return _.get(currentSelection, itemText);
};

const autocompleteProps = Object.fromEntries(
  Object.entries(VAutocomplete.options.props).filter(
    arr => arr[0] != 'readonly'
  )
);

export default {
  functional: true,
  name: 'BAutocomplete',
  props: {
    readOnly: { type: Boolean, default: false },
    displayString: String,
    uuid: String,
    propPath: String,
    formRef: String,
    ...autocompleteProps
  },
  render(createElement, context) {
    if (!context.props.readOnly) {
      const customData = {
        class: ['b-autocomplete', 'b-autocomplete--input'],
        props: {
          outlined: true,
          dense: true,
          hideDetails: 'auto',
          hideNoData: true
        }
      };

      context.data.props = context.props;
      _.mergeWith(context.data, customData, function(objValue, srcValue) {
        if (_.isArray(objValue)) return objValue.concat(srcValue);
      });

      const slot = ({ error, deleteServerError }) => {
        const data = {
          ...context.data,
          props: {
            ...context.data.props,
            errorMessages: error
          },
          on: {
            ...context.data.on,
            keyup: () => deleteServerError(),
            input: () => deleteServerError(),
          }
        }
        return createElement(VAutocomplete, data, context.children);
      }

      return createElement(ValidationField,
          {
            props: {
              uuid: context.data.props.uuid,
              propPath: context.data.props.propPath,
              formRef: context.data.props.formRef
            },
            scopedSlots: { default: slot }
          });
    } else {
      const customData = {
        props: {
          label: context.props.label,
          value:
            context.props.displayString || currentSelectionText(context.props)
        }
      };
      return createElement(BReadOnlyTextField, customData);
    }
  }
};
</script>

<style lang="scss" >
.b-autocomplete {
  &--input > .v-input__control {
    padding-top: 4px;
  }

  & .v-input__append-inner {
    display: none;
  }
}
</style>
